import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import {
    FAILURE_CUSTOMER_APPLIANCES,
    FAILURE_CUSTOMER_COMPLAINTS,
    REQUEST_CUSTOMER_APPLIANCES,
    REQUEST_CUSTOMER_COMPLAINTS,
    SUCCESS_CUSTOMER_APPLIANCES,
    SUCCESS_CUSTOMER_COMPLAINTS,
} from './actions';

/* Customer Appliances */
export function customerAppliancesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_APPLIANCES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_APPLIANCES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_APPLIANCES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Complaints */
export function customerComplaintsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_COMPLAINTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_COMPLAINTS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_COMPLAINTS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
